import token_formatter from 'common/token_formatter.js'
import { textProcessor, buildLink } from 'common/links'
import { toDate } from 'common/string_utils.js'

const buildHighlight = function(text, _data) {
  return `<strong class="highlight"><em>${text}</em></strong>`
}

const buildHighlightWithButtons = function(text, _data) {
  return `
    <span class="highlight" data-highlight="">
      <button class="highlight_first"><i class="fas fa-angle-double-left"></i></button>
      <button class="highlight_prev"><i class="fas fa-angle-left"></i></button>
      <em>${text}</em>
      <button class="highlight_next"><i class="fas fa-angle-right"></i></button>
      <button class="highlight_last"><i class="fas fa-angle-double-right"></i></button>
    </span>
  `
}

var filters = {

  char_limit: function(title,limit){
    var title_str = title.toString()
    if (title_str.length > limit)
      title_str = title_str.substring(0, limit).concat("...")
    return title_str
  },

  highlight: function(text, expressions, stemm_text = false, add_buttons = false) {
    if (!expressions || expressions.length == 0)
      return text

    var matching_tokens = expressions
    var text_to_replace = text
    var newTextFunction = add_buttons ? buildHighlightWithButtons : buildHighlight
    if (stemm_text) {
      var matching_tokens = token_formatter.get_matching_tokens_in_text(matching_tokens, text)
      matching_tokens.forEach(function(clean_token) {
        var re = new RegExp("\\b"+clean_token+"\\b","gi")
        text_to_replace = text_to_replace.replace(re, newTextFunction('$&'))
      })
    } else {
      var expresionsData = expressions.reduce((obj, item) => {
        obj[item] = {}
        return obj
      }, {})
      text_to_replace = textProcessor(text_to_replace, expresionsData, newTextFunction)
    }

    return text_to_replace
  },

  clean_bolds: function(text) {
    var re = new RegExp("\<\/?b\>","gi")

    return text.replace(re, '')
  },

  highlight_substring: function(text, regex, reverse=false) {
    if (reverse) {
      return `<strong>${text.replace(regex, '</strong>$&<strong>')}</strong>`
    } else
      return text.replace(regex, '<strong>$&</strong>')
  },

  format_percentage: function(number, decimals) {
    return (number*100).toFixed(decimals) + "%"
  },

  parse_format_date: function(date_string) {
    var date = new Date(date_string)
    return date.toLocaleDateString()
  },

  remove_intro_chars: function(text) {
    return text.replace(/\\\\n|\\n|\n/g, '')
  },

  applyLinks(text, linksData) {
    return textProcessor(text, linksData, buildLink.bind(this, gon.app_tolgeo))
  },

  format_field_value_to_string: function(value) {
    var string = value
    if (Array.isArray(value))
      string = value.join(', ')
    return string
  },
  format_descriptor_date: function(value) {
    if (!value) return value

    const normalized = String(value).replace(' UTC', 'Z').replace(' ', 'T')
    const date = toDate(normalized)
    if (Number.isNaN(date.getTime())) return value

    return new Intl.DateTimeFormat('es-ES', {
      timeZone: 'Europe/Madrid',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date)
  },

  limit_string_length: function(str, limit, ellipsis=true) {
    return str.length > limit ? str.substring(0, limit) + (ellipsis ? '...' : '') : str;
  },

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  },
  titleize_label(str) {
    return str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
  },
  titleize_text(str) {
    str = str.trim()
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }
}
export default filters
